<!-- eslint-disable -->
<template lang="pug">
    .room(:style='roomStyle')
        img.detective__background(
            :style='roomStyle',
            :class="{'detective__background_fullscreen': isFullScreen}",
            src='../../../../assets/images/detective/chapter_1/background/background.png'
        )
        .detective__shadows(:style='roomStyle')
            .column.left-interlocutor
                img.detective__left-interlocutor__shadow(src='../../../../assets/images/detective/chapter_1/background/shadow_clevik.png')
            .column.center-column
            .column.right-interlocutor
                img.detective__right-interlocutor__shadow(src='../../../../assets/images/detective/chapter_1/background/shadow_detective.png')
        img.detective__background(
            :style='roomStyle',
            :class="{'detective__background_fullscreen': isFullScreen}",
            src='../../../../assets/images/detective/chapter_1/background/grid.png'
        )
        img.detective__interior(
            :style='roomStyle',
            :class="{'detective__interior_fullscreen': isFullScreen}",
            src='../../../../assets/images/detective/chapter_1/background/interior.png'
        )
        .detective__interlocutors(:style='roomStyle')
            .column.left-interlocutor
                img.detective__left-interlocutor(
                    :class="{'detective__left-interlocutor_introduction': isIntroduction}",
                    :src='clevikSrc'
                )
            .column.center-column
            .column.right-interlocutor
                img.detective__right-interlocutor(
                    :class="{'detective__right-interlocutor_introduction': isIntroduction}",
                    :src='detectiveSrc',
                    @click="$emit('playDialog', 'Suitcase')"
                )
                .detective__items
                    .detective__items__first-items
                        img.detective__item.detective__items__magnifier(
                            v-if="items.includes('Magnifier')",
                            src='../../../../assets/images/detective/chapter_1/items/magnifier.png',
                            @click="$emit('playDialog', 'Magnifier')"
                        )
                        img.detective__item.detective__items__lantern(
                            v-if="items.includes('Lantern')",
                            src='../../../../assets/images/detective/chapter_1/items/lantern.png',
                            @click="$emit('playDialog', 'Lantern')"
                        )
                    .detective__items__second-items
                        img.detective__item.detective__items__notepad(
                            v-if="items.includes('Notepad')",
                            src='../../../../assets/images/detective/chapter_1/items/notepad.png',
                            @click="$emit('playDialog', 'Notepad')"
                        )
                        img.detective__item.detective__items__camera(
                            v-if="items.includes('Camera')",
                            src='../../../../assets/images/detective/chapter_1/items/camera.png',
                            @click="$emit('playDialog', 'Camera')"
                        )
                    .detective__items__third-items
                        img.detective__item.detective__items__pen(
                            v-if="items.includes('Pen')",
                            src='../../../../assets/images/detective/chapter_1/items/pen.png',
                            @click="$emit('playDialog', 'Pen')"
                        )
                        img.detective__item.detective__items__dictaphone(
                            v-if="items.includes('Dictaphone')",
                            src='../../../../assets/images/detective/chapter_1/items/dictaphone.png',
                            @click="$emit('playDialog', 'Dictaphone')"
                        )
                        img.detective__item.detective__items__book(
                            v-if="items.includes('Book')",
                            src='../../../../assets/images/detective/chapter_1/items/book.png',
                            @click="$emit('playDialog', 'Book')"
                        )
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            items: Array,
            detectiveSrc: String,
            clevikSrc: String,
            isIntroduction: Boolean,
            isFullScreen: Boolean,
        },
        computed: {
            roomHeight () {
                if (this.isMobile || this.isFullScreen) {
                    return '100vh';
                }
                return 'calc(100vh - 60px)';
            },
            roomStyle () {
                let width = '100%';
                let height = this.roomHeight;
                return {width: width, height: height};
            }
        }
    }
</script>

<style scoped lang="scss">
    .room {
        display: flex;
        justify-content: center;
    }

    .columns {
        height: 100%;
        flex-grow: 1;
    }

    .column {
        display: flex;
        align-items: flex-end;
    }

    .left-interlocutor {
        justify-content: flex-end;
    }

    .right-interlocutor {
        justify-content: flex-start;
    }

    .center-column {
        width: 25%;
        margin: 0 auto;
        position: relative;
    }

    .detective__background, .detective__interior {
        position: absolute;
        border-radius: 40px;
        &_fullscreen {
            border-radius: 0;
        }
    }

    .detective__interlocutors, .detective__shadows {
        position: absolute;
        display: flex;
        justify-content: space-between;
    }

    .detective__left-interlocutor {
        position: relative;
        height: 60vh;
        left: 3%;
        top: 0;
        padding-bottom: 2%;
    }

    .detective__left-interlocutor_introduction {
        top: 0;
        left: 12%;
        padding-left: 2%;
    }

    .detective__left-interlocutor__shadow {
        top: 0;
        padding-right: 8%;
        position: relative;
        height: 11vh;
    }

    .detective__right-interlocutor {
        position: relative;
        height: 75vh;
        right: 12%;
        bottom: 2%;
    }

    .detective__right-interlocutor_introduction {
        top: 0;
        right: 0;
        padding-left: 2%;
    }

    .detective__right-interlocutor__shadow {
        top: 0;
        position: relative;
        height: 13vh;
    }

    .detective__item {
        cursor: pointer;
    }

    .detective__items {
        position: absolute;
        display: flex;
        flex-direction: column;
        bottom: 24.95vh;
        height: 26vh;
        left: 64.7%;
        width: calc(75vh / 1.77181208);
        @media screen and (min-width: 1023px) {
            bottom: 22vh;
            left: 63.3%;
        }
    }

    .detective__items__third-items {
        display: flex;
        align-items: center;
        height: 15vh;
    }

    .detective__items__magnifier {
        position: relative;
        height: 11vh;
        left: 32%;
    }

    .detective__items__lantern {
        position: relative;
        height: 10.1vh;
        left: 35%;
        top: 1vh;
    }

    .detective__items__notepad {
        position: relative;
        height: 5.96vh;
        left: 18%;
    }

    .detective__items__camera {
        position: relative;
        height: 5.4vh;
        left: 21%;
        top: 3vh;
    }

    .detective__items__pen {
        position: relative;
        height: 4.64vh;
        left: 32%;
        bottom: 5vh;
    }

    .detective__items__dictaphone {
        position: relative;
        height: 4.92vh;
        right: 5%;
        bottom: 3.8vh;
    }

    .detective__items__book {
        position: relative;
        height: 5.87vh;
        right: 3%;
        bottom: 1.2vh;
    }

</style>
